/**
 * Given an array of selected values and a value, adds the value if it does not
 * exist in the selected array, or removes it if it does.
 * @param {Array} selected - An array of selected values.
 * @param {string|number} value - The value to toggle.
 * @returns {Array} The modified array of selected values.
 */
const toggleSelected = (selected, value) => (selected.includes(value)
  ? selected.filter((compare) => value !== compare)
  : [...selected, value]);

export default toggleSelected;
